import React from "react";
import "./_styles.scss";
import { UserPermissions } from "../../../../../src/definitions";
import {  securityService } from "../../../../../src/_global/services";

interface RoleCardProps {
  data?: any;
}

export default function RoleCard({ data }: RoleCardProps) {
  const { rolename, is_active } = data;

  return (
    securityService.checkRoleAccess(UserPermissions.viewUserRoles)?
    (
    <div className="user-card">
      <div className="full-name">{`${rolename}`}</div>
      <div className="status">{is_active? "Active":"Inactive"}</div>
    </div>
    ): 
    (
    <div></div>
    )
  );
}
